module.exports = __webpack_public_path__ + "static/video-7ed6e660dd4d913034023b901e318e0b.mp4";